import { GoogleMap } from "@react-google-maps/api";
import { Card, CardBody, Col } from "reactstrap";
import { containerStyle, defaultCenter } from "../../../../Data/MiscellaneousData/MapsData";
import CommonCardHeader from "../../../../Utils/CommonComponents/CommonCardHeader";
import { PolylinesTitle } from "../../../../Utils/Constants";

export default function PolylineMaps() {
  // const { isLoaded } = useJsApiLoader({
  //     id: "google-map-script",
  //     googleMapsApiKey:
  //         "https://maps.googleapis.com/maps/api/js?key=your_api_key",
  // });
  return (
    <Col xl={6}>
      <Card>
        <CommonCardHeader headClass="pb-0" title={PolylinesTitle} />
        <CardBody>
          <div className="map-js-height">
            <div id="gmap-simple" className="map-block">
              <GoogleMap mapContainerStyle={containerStyle} center={defaultCenter} zoom={10}></GoogleMap>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
}
